import { render, staticRenderFns } from "./tableComponent.vue?vue&type=template&id=b04ab8a4"
import script from "./tableComponent.vue?vue&type=script&scoped=true&lang=js"
export * from "./tableComponent.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./tableComponent.vue?vue&type=style&index=0&id=b04ab8a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports